import React from "react";
import clsx from "clsx";

import {
  HvBaseSwitch,
  HvBaseSwitchProps,
  HvTypography,
} from "@hitachivantara/uikit-react-core";

import useStyles from "./styles";

interface SwitchColumnCellProps {
  checked: boolean;
  value: number | string | undefined;
  switchLabel: string;
  falseLabel?: string;
  trueLabel?: string;
  switchProps?: HvBaseSwitchProps;
}

const SwitchColumnCell: React.FC<SwitchColumnCellProps> = ({
  checked,
  value,
  switchLabel,
  falseLabel,
  trueLabel,
  switchProps,
}) => {
  const classes = useStyles();

  return (
    <>
      {falseLabel != null && (
        <HvTypography
          aria-hidden="true"
          variant="normalText"
          className={clsx(classes.switchProperties, classes.switchNo)}
        >
          {falseLabel}
        </HvTypography>
      )}
      <HvBaseSwitch
        aria-label={switchLabel}
        checked={checked}
        value={value}
        readOnly
        {...switchProps}
      />
      {trueLabel != null && (
        <HvTypography
          aria-hidden="true"
          variant="normalText"
          className={clsx(classes.switchProperties, classes.switchYes)}
        >
          {trueLabel}
        </HvTypography>
      )}
    </>
  );
};

export default SwitchColumnCell;
